<template>
  <div>
    <LazyMagazineArticleHeaderImage
      v-if="img"
      :image="img"
      :image-alt="articleGetters.getTitle(article)"
    />
    <h1
      data-test-id="magazine-article-title"
      class="text-h3 text-[26px] mt-4 font-semibold leading-8"
    >
      {{ articleGetters.getTitle(article) }}
    </h1>
    <LazyMagazineArticleCardMetaData
      class="text-sm mt-4"
      context="articlePage"
      :author="articleGetters.getAuthor(article)"
      :date="
        formatDate(
          articleGetters.getUpdatedAt(article),
          $i18n.locale.toString(),
          'dd. DD. MMM YYYY'
        )
      "
    />
    <hr class="my-3 border-gray-600" />
  </div>
</template>

<script lang="ts" setup>
import type { StrapiMagazineArticle } from '~/composables/types/strapi/strapi-magazine'
const { isMobile } = useDevice()
const { article = undefined } = defineProps<{
  article: StrapiMagazineArticle
}>()

const img = articleGetters.getHeaderImageUrl(
  article,
  isMobile ? 'small' : 'large'
)
</script>
